export const AIDA_LAUNCH_STORAGE_KEY = 'aida-launch';

export interface AidaLaunchParams {
  question?: string;
  shortQuestion?: string;
  autoSend?: boolean;
}

export function peekAidaLaunchParams(): AidaLaunchParams | null {
  if (typeof window === 'undefined') return null;
  const raw = sessionStorage.getItem(AIDA_LAUNCH_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AidaLaunchParams;
  } catch {
    return null;
  }
}

export function readAidaLaunchParams(): AidaLaunchParams | null {
  const params = peekAidaLaunchParams();
  if (params) sessionStorage.removeItem(AIDA_LAUNCH_STORAGE_KEY);
  return params;
}

export function storeAidaLaunchParams(params: AidaLaunchParams): void {
  sessionStorage.setItem(AIDA_LAUNCH_STORAGE_KEY, JSON.stringify(params));
}
